import { CacheStorage, QueryBus } from '@skylab-shared/core';
import { Constructor } from '@skylab-shared/types';
import { PagedCollectionQuery } from '../query/paged-collection-query';
import { CacheableQuickListDataSourceBase } from './cacheable-quick-list-data-source.service-base';

export class QuickListDataSourceFactoryBase {

    public constructor(
        private queryBus: QueryBus,
        private cacheStorage: CacheStorage
    ) { }

    public createCacheable<TQuery extends PagedCollectionQuery<TItem>, TItem, TParams = unknown>(queryType: Constructor<TQuery>, paramsFunction?: () => TParams): CacheableQuickListDataSourceBase<TQuery, TItem> {
        const dataSource = <CacheableQuickListDataSourceBase<TQuery, TItem>>(new CacheableQuickListDataSourceBase(<QueryBus>this.queryBus, <CacheStorage>this.cacheStorage));
        dataSource.setQueryType(queryType);
        dataSource.setParamsFunction(paramsFunction || null);
        return dataSource;
    }
}
